import 'PublicPath';

import renderReact from 'utils/renderReact';

import MainApp from './MainApp.dynamic';
import { configureMainStore } from './store';

export default renderReact('main', MainApp, configureMainStore);
